export const pageMeta = () => ({
    page: {
        url: location.href,
    },
});
//# sourceMappingURL=meta.js.map